import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import axios from "axios";
import $ from 'jquery';
import './panel.css';
import frm from './formAux.js'
import { mode } from "d3"

var descriptor = {};
var origDescriptor = null;

function px(v) { return v + 'px'; }
function pc(v) { if (v < 0) v = 0; if (v > 100) v = 100; return Math.round(v) + '%'; }
function val(v) { v = parseFloat(v); if (isNaN(v)) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring(o) { return typeof (o) == 'string'; }
function isarray(o) { return o instanceof Array; }
function isobj(o) { return o instanceof Object; }
function isnumber(o) { return typeof (o) == 'number' && !isNaN(o); }
function defined(o) { return typeof (o) != 'undefined'; }
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec() { return new Date().getTime(); }
function getsec() { return Math.round(getmsec() / 1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig, '').toLowerCase() }
function iarray(v, n) {
    var ret = [];
    for (var i = 0; i < n; i++)
        ret.push(v instanceof Object ? clone(v) : v);
    return ret;
}




function setDescriptor(bool) {
    for (var k in bool) {
        descriptor[k] = bool[k];
    }
}

function exists(o) {
    if (!o) return false;
    if (!isobj(o)) return false;
    return Object.keys(o).length > 0;
}

function processDescriptor(desc) {
    try {
        desc = JSON.parse(desc);
        desc.name = model.name;
        console.log('processDescriptor', desc)
        for( var k of modelCore ) model[k] = desc[k];
        initPanel();
    } catch(e) { console.error(e) }
 }

let LLMS = null;
async function getLLMS() {
    if( LLMS ) return LLMS;
    let llms = (await window.post( 'get_llms', {})).data;
    LLMS = {
        "key": "llm.platform",
        "title": "LLM Platform",
        "label": "",
        "placeholder": "select LLM Platform",
        "type": "dropdown",
        "forceValue": true,
        // "callback": function(v) { console.log( 'llm.platform', v )},
        "options": [],
    };

    for (let l in llms) {
        let params = llms[l].parameters || [];
        let psubs = [];
        if( params.find( p => p.match(/^aws_/))) {
            params = params.filter( ( p => !p.match(/^aws_/)));
            let awsCreds = (await window.post('get_aws_credentials_options_list', {
                type: "llm.parameters.aws_security_type",
                key: "llm.parameters.aws_access_key_id",
                secret: "llm.parameters.aws_secret_access_key",
                region: "llm.parameters.aws_region",
                role: "llm.parameters.aws_role_arn",
                extid: "llm.parameters.aws_external_id",
            })).data;
            psubs = awsCreds;
        }
        for (let p of params) {
            psubs.push({
                "title": p,
                "key": "llm.parameters." + p,
                "placeholder": "Enter " + p,
                "required": "Parameter required",
                "type": "string",
            })
        }
        let options = llms[l].options || [];
        let opts = [];
        for( let o of options ) {
            opts.push( {
                "value": o,
                "label": o,
                "subFields": psubs,
            })
        }
        LLMS.options.push({
            "value": l,
            "label": l,
            // "callback": function(v) { console.log( 'llm.model', v )},
            "subFields": [{
                "key": "llm.model",
                "title": "LLM Model",
                "label": "",
                "placeholder": "select LLM Model",
                "type": "dropdown",
                "forceValue": true,
                "options": opts,   
            }],
        })
    }

    // console.log( 'LLMS', JSON.stringify(LLMS, null, '\t') );
    return LLMS;
}



let oldModelType = null;
let bptid = null;

async function typeAdjust(){
    frm.convertSelects($('select'));

    $('.mcustom').show();
    $('.panel-labels').show();
    $('.panel-relationships').show();
    $('.model-payload').show();
    $('.apiurl').show();

    model.type = ($('#modeltype').val() || '').trim();
    
    if( model.type.match(/(pii_redaction|classification_prompt|summarization_prompt|qa_prompt)/) ) {
        if (model.type != oldModelType || !model.llm || !model.llm.promptText ) {
            oldModelType = model.type;
            if( !model.llm ) model.llm = {};
            model.llm.testText = "Charles Darvin\nBeagle Street 1687\n\nObjective:\nHighly skilled software engineer with a passion for developing innovative solutions and a strong background in various programming languages. Seeking a challenging position in a dynamic organization where I can apply my technical expertise and contribute to the development of cutting-edge software solutions.\n\nEducation:\nBachelor of Science in Computer Science\nOxford, 1999\n\nSkills:\n\nProgramming Languages: Java, Python, C++, JavaScript\nWeb Development: HTML, CSS, React, Node.js\nDatabase Management: SQL, MongoDB\nVersion Control: Git\nSoftware Development Lifecycle (SDLC)\nObject-Oriented Design and Analysis (OOAD)\nProblem-solving and debugging skills\nStrong knowledge of algorithms and data structures\nTeamwork and collaboration\nExcellent verbal and written communication skills\nExperience:\nSoftware Engineer Intern\nBeagle INC, 2020-Present\n\nCollaborated with a team of software engineers to develop and maintain web applications using Java and JavaScript.\nParticipated in code reviews and provided feedback to ensure high-quality code.\nImplemented new features and resolved bugs in existing software applications.\nAssisted in database management and optimization for improved performance.\nConducted unit testing and assisted in integration testing to ensure functionality and reliability.\nSoftware Developer\nOxtech, 2005-1029\n\nEnglish (Fluent)\nFrench (Intermediate)\nReferences:\nAvailable upon request";
            if( model.type == 'classification_prompt' ) {
                model.llm.promptText = "Classify the following document into given classes Return the confidence score corresponding to every class. Keep the default class as {default_class} in case the document belongs to none of the classes. {classes}, Document: {document}.";
            }
            else if( model.type == 'summarization_prompt' ) {
                model.llm.promptText = "Summarize the following document using maximum {max_words} words while maintaining the essence of the document. Give a to the point summary and do not make up details that are not present in the text. Use the information in the document only to perform summarization. \n\nDocument: {document}\n\n Summary:";
            } 
            else if( model.type == 'qa_prompt' ) {
                // model.llm.promptText = "What is the name of the job candidate on the following Document: {document}";
            }
            else if( model.type == 'pii_redaction' ) {
                model.llm.promptText = "";
            }
            // $('#modelendpoint').val(window.postURL('test_prompt_model'))
        }
    }
    $('.mfield').hide();
    $('.panel-labels').show();
    $('.panel-relationships').show();
    $('#topbuttons').show();
    if (model.type.match(/(custom_ocr)/)) {
        $('.panel-relationships').hide();
    }
    if (model.type.match(/(custom_bulkimageclassification|ocr_extractor)/)) {
        var testPayload = defaultCustomBulkImageClassificationTest;
        if( model.type == 'ocr_extractor') {
            testPayload = defaultCustomOcrExtractTest
        }
        $('#modelpayload').val(JSON.stringify(model.customTestPayload || testPayload, null, '    ')).on('change', modelTextSet)
        $('.mcustom').show();

        var testEndPoint = window.postURL('test_bulk_image_model');
        $('.panel-labels').hide();
        $('.panel-relationships').hide();
        $('#topbuttons').hide();
        if( model.type == 'ocr_extractor') {
            testEndPoint = window.postURL('test_ocr_extractor')
        }
        $('#modelendpoint').val(model.endpoint || testEndPoint)
    }
    else if (model.type.match(/(custom|ocr_extractor)/)) {
        var testPayload = model.type == 'custom_ner' ? defaultCustomNerTestPayload : defaultCustomComprehendTestPayload;
        
        $('#modelpayload').val(JSON.stringify(model.customTestPayload || testPayload, null, '    ')).on('change', modelTextSet)
        $('.mcustom').show();

        
        var testEndPoint = model.type == 'custom_ner' ? window.postURL('test_predict_multipage') : window.postURL('test_ocr_model');
        $('#modelendpoint').val(model.endpoint || testEndPoint)
    }
    else if (model.type.match(/_embedding/)) {
        $('.mcustom').show();
        $('.panel-labels').hide();
        $('.panel-relationships').hide();
        $('.model-payload').hide();
        $('.model-parameters').hide();
        $('.apiurl').hide();
    }
    else if (model.type.match(/fallback/)) {
        $('.mcustom').show();
        $('.panel-labels').hide();
        $('.panel-relationships').hide();
        $('.model-payload').hide();
        $('.model-parameters').hide();
        $('.apiurl').hide();
    }    
    else if (model.type.match(/(pii_redaction|classification_prompt|summarization_prompt|qa_prompt)/)) {
        $('.mcustom').show();
        $('.panel-labels').hide();
        $('.panel-relationships').hide();
        $('.model-payload').hide();
        $('.model-parameters').hide();
        $('.apiurl').hide();

    }
    else $('.msage').show();

    $('.model-prompt-parameters').html('');
    let promptParam = $('.model-prompt-parameters').addClass('modelid mb-3');
    promptParam.html('');
    if (model.type.match(/(pii_redaction|classification_prompt|summarization_prompt|qa_prompt)/)) {
        // alert( promptParam.html())

        let pconfig = []

        if (model.type != 'pii_redaction') {
            let llms = await getLLMS();
            pconfig.push( llms );
        }

        if (model.type != 'qa_prompt') {
            pconfig.push(
                {
                    "title": "Max. text length (characters)",
                    "key": "llm.maxTextLength",
                    "placeholder": "",
                    "default": 4096,
                    "type": "int",
                }
            )
        }
        
        if (model.type != 'pii_redaction') {
            pconfig.push(
                {
                    "title": "Default Temperature (0-1)",
                    "key": "llm.temperature",
                    "placeholder": "enter temperature",
                    "default": 0,
                    "type": "float",
                }
            )
        }

        pconfig.push( {
            "key": "modelConcurrency",
            "title": "Max. number of concurrent invocations",
            "label": "",
            "placeholder": "Enter number",
            "default": 10,
            "type": "int",
        })


        pconfig.push({
            "label": 'Test model',
            "type": 'button',
            "callback": testModel,
        })

//         if (model.type == 'qa_prompt') {
//             $('.model-prompt-parameters').html('');

//             $('.model-parameters-compiled-prompt').remove();
//             let compiledPrompt = $('<div>').addClass('model-parameters-compiled-prompt').html('<label>Compiled Prompt</label>')
//             $('.model-prompt-parameters').before( compiledPrompt )
//             function buildPrompt() {
//                 clearTimeout( bptid );
//                 bptid = setTimeout( function(){
//                     console.log( 'buildPrompt', model.llm )
//                     let ptext = [];
//                     ptext.push( model.llm.promptHead )
//                     ptext.push( 'Question: [Question Here]')
//                     ptext.push( 'Answer: [Answer Here]')
//                     for( let o of model.llm.outputFormat ) {
//                         ptext.push( o.name + ': [' + (o.description || o.name) + ']')
//                     }
//                     ptext.push( 'Score: [Score Here]')

//                     ptext.push( model.llm.aditionalInstructions)
//                     ptext.push( model.llm.examples)
//                     ptext.push( model.llm.promptEnd)

//                     model.llm.promptText = ptext.join('\n\n');
//                     $('.model-parameters-compiled-prompt').html('<label>Compiled Prompt</label><p>'+model.llm.promptText.replace(/\n/g, '<br>')+'</p>')
//                 }, 300 );
//             }
//             pconfig.push(
//                 {
//                     "title": "Prompt Head",
//                     "key": "llm.promptHead",
//                     "placeholder": "Enter prompt head",
// "default": `Use the following pieces of context to answer the question at the end. If you don't know the answer, just say that you don't know, don't try to make up an answer. 

// In addition to giving an answer, also return a score of how fully it answered the user's question. This should be in the following format: `,
//                     "type": "textarea",
//                     "css": { height: 150 },
//                     "callback": buildPrompt,
//                 }
//             );
//             let mout = {
//                 'name': { type: 'text', placeholder: 'Enter Output Name', fforceWidth: 200, label: 'Name' },
//                 'description': { type: 'text', placeholder: 'Enter Output Description', fforceWidth: 400, label: 'Description' },
//             }
//             pconfig.push(
//                 {
//                     "title": "Prompt Output Format",
//                     "key": "llm.outputFormat",
//                     "fieldKey": 'name',
//                     "defaultField": 'name',
//                     "type": "gridlist",
//                     "fields": mout,
//                     "arrayOutput": true,
//                     "callback": buildPrompt,
//                 }
//             )
//             pconfig.push(
//                 {
//                     "title": "Additional instructions",
//                     "key": "llm.aditionalInstructions",
//                     "placeholder": "Enter aditional instructions",
//                     "default": `How to determine the score:  
// - Higher is a better answer  
// - Better responds fully to the asked question, with sufficient level of detail  
// - If you do not know the answer based on the context, that should be a score of 0  
// - Don't be overconfident!`,
//                     "type": "textarea",
//                     "css": { height: 150 },
//                     "callback": buildPrompt,
//                 }
//             );
//             pconfig.push(
//                 {
//                     "title": "Examples (Should follow the output format)",
//                     "key": "llm.examples",
//                     "placeholder": "Enter examples",
//                     "default": `Example #1  
// Context:  
// ---------  
// Apples are red  
// ---------  
// Question: what color are apples?  
// Helpful Answer: red  
// Score: 100`,
//                     "type": "textarea",
//                     "css": { height: 150 },
//                     "callback": buildPrompt,
//                 }
//             );
//             pconfig.push(
//                 {
//                     "title": "Prompt END. {context} and {question} are input variables later used and MUST be present. Prompt should end as:<br>[….\nfirst output key:]",
//                     "key": "llm.promptEnd",
//                     "placeholder": "Enter prompt end",
//                     "default": `Begin! 
// Context: 
// --------- 
// {context} 
// --------- 
// Question: {question} 
// Answer:`,
//                     "type": "textarea",
//                     "css": { height: 150 },
//                     "callback": buildPrompt,
//                 }
//             );
//             pconfig.push(
//                 {
//                     "title": "Top-k (1-10)",
//                     "key": "llm.top_k",
//                     "placeholder": "enter top_k",
//                     "default": 5,
//                     "type": "int",
//                 }
//             )

//             pconfig.push(
//                 {
//                     "title": "Test Text",
//                     "key": "llm.testText",
//                     "placeholder": "Enter test text",
//                     "type": "textarea",
//                     "css": { height: 200 },
//                 }
//             );

//             pconfig.push(
//                 {
//                     "title": "Test Question",
//                     "key": "llm.testQuestion",
//                     "placeholder": "Enter test question",
//                     "type": "text",
//                     // "css": { height: 200 },
//                 }
//             );

//             pconfig.push({
//                 "label": 'Test model',
//                 "type": 'button',
//                 "callback": testModel,
//             })
//         }
//         else {
//             $('.model-prompt-parameters').html('');

//             if (model.type != 'pii_redaction') {
//                     pconfig.push(
//                         {
//                             "title": "Default Prompt",
//                             "key": "llm.promptText",
//                             "placeholder": "Enter default prompt text",
//                             "type": "textarea",
//                             "css": { height: 200 },
//                         }
//                     );
//                     pconfig.push(
//                         {
//                             "title": "Temperature (0-1)",
//                             "key": "llm.temperature",
//                             "placeholder": "enter temperature",
//                             "default": 0,
//                             "type": "float",
//                         }
//                     )            
//             }
    
//             pconfig.push(
//                 {
//                     "title": "Test Text",
//                     "key": "llm.testText",
//                     "placeholder": "Enter test text",
//                     "type": "textarea",
//                     "css": { height: 200 },
//                 }
//             );
    
//             if( model.type == 'classification_prompt' ) {
//                 let mclasses = {
//                     'name': { type: 'text', placeholder: 'Enter Class Name', fforceWidth: 300, label: '' },
//                     // 'xxx': { type: 'text', placeholder: 'Enter Class Name', fforceWidth: 300, label: 'xxx' },
//                 }
        
//                 pconfig.push(
//                     {
//                         "title": "Classification Classes",
//                         "key": "llm.classes",
//                         "fieldKey": 'name',
//                         "defaultField": 'name',
//                         "type": "gridlist",
//                         "fields": mclasses,
//                         "arrayOutput": true,
//                     }
//                 )
//                 pconfig.push(
//                     {
//                         "title": "Default Class",
//                         "key": "llm.defaultClass",
//                         "placeholder": "Enter default Class",
//                         "type": "string"
//                     } 
//                 )
//             }
    
//             if( model.type == 'summarization_prompt' ) {
//                 pconfig.push(
//                     {
//                         "title": "Max words",
//                         "key": "llm.summaryMaxWords",
//                         "placeholder": "Enter number",
//                         "default": 20, 
//                         "type": "int"
//                     } 
//                 )
//             }
    
//             if( model.type == 'pii_redaction' ) {
//                 let redact = {
//                     'Financial': [
//                         'BANK_ACCOUNT_NUMBER',
//                         'BANK_ROUTING',
//                         'CREDIT_DEBIT_NUMBER',
//                         'CREDIT_DEBIT_CVV',
//                         'CREDIT_DEBIT_EXPIRY',
//                         'PIN',
//                     ],
//                     'Personal': [
//                         'NAME',
//                         'ADDRESS',
//                         'PHONE',
//                         'EMAIL',
//                         'AGE',
//                     ],
//                     'Technical Security': [
//                         'USERNAME',
//                         'PASSWORD',
//                         'URL',
//                         'AWS_ACCESS_KEY',
//                         'AWS_SECRET_KEY',
//                         'IP_ADDRESS',
//                         'MAC_ADDRESS',
//                     ],
//                     'National': [
//                         'SSN',
//                         'PASSWORD_NUMBER',
//                         'DRIVER_ID',
//                     ],
//                     'Other': [
//                         'DATE_TIME',
//                     ]
//                 }
    
//                 pconfig.push({
//                     "title": "Redaction options",
//                     "label": "Select the informations classes to be redacted",
//                     "type": 'title',
//                 });
    
    
//                 for( let rtype in redact ) {
//                     let title = rtype;
//                     for( let o of redact[rtype] ) {
//                         pconfig.push( 
//                             {
//                                 "key": "llm.redact."+o,
//                                 "title": title,
//                                 "label": o,
//                                 "type": "boolean",
//                                 "default": true,
//                                 "css": { marginLeft: 50}
//                             }
//                         )
//                         title = '';
//                     }
//                 }
//             }
    
//             pconfig.push({
//                 "label": 'Test model',
//                 "type": 'button',
//                 "callback": testModel,
//             })
//         }

        promptParam.html('')
        frm.configOptions(promptParam, pconfig, model);        
    }
    else if (model.type.match(/_embeddings/)) {
        // alert( promptParam.html())

        let pconfig = []

        let awsCreds = (await window.post('get_aws_credentials_options_list', {
            type: "embedding_model_config.aws_security_type",
            key: "embedding_model_config.aws_access_key_id",
            secret: "embedding_model_config.aws_secret_access_key",
            region: "embedding_model_config.aws_region",
            role: "embedding_model_config.aws_role_arn",
            extid: "embedding_model_config.aws_external_id",
        })).data;
        let embeddings = (await window.post('get_embedings',{modelType: model.type})).data;
        let options = 
        embeddings[0].options.push( {
            "value":"custom_model",
            "label":"Custom Model",
            "subFields":[
                {
                    "key": "embedding_model_config.endpoint_name",
                    "title": "Endpoint Name",
                    "label": "",
                    "placeholder": "Endpoint Name",
                    "required": true,
                    "type": "string",
                },
                {
                    "key": "embedding_model_config.dimension",
                    "title": "Dimension",
                    "label": "",
                    "placeholder": "Enter Dimention",
                    "default": 768,
                    "required": true,
                    "type": "int",
                },
                awsCreds[0],            
            ]
        })

        

        pconfig = [...embeddings];

        pconfig.push( {
            "key": "modelConcurrency",
            "title": "Max. number of concurrent invocations",
            "label": "",
            "placeholder": "Enter number",
            "default": 10,
            "type": "int",
        })

        if( model.type == 'text_embeddings') {
            pconfig.push( {
                "key": "textChunkSize",
                "title": "Text Chunk Size",
                "label": "",
                "placeholder": "Enter number",
                "default": 128,
                "type": "int",
            })
            pconfig.push( {
                "key": "textChunkOverlap",
                "title": "Text Overlap Size (between chunks)",
                "label": "",
                "placeholder": "Enter number",
                "default": 32,
                "type": "int",
            })
        }
        promptParam.html('')
        frm.configOptions(promptParam, pconfig, model);        
    }
    else if (model.type.match(/fallback/)) {
        // alert( promptParam.html())

        let pconfig = []

        let llms = await getLLMS();
        pconfig.push(llms);

        // pconfig.push( {
        //     "key": "modelConcurrency",
        //     "title": "Max. number of concurrent invocations",
        //     "label": "",
        //     "placeholder": "Enter number",
        //     "default": 10,
        //     "type": "int",
        // })

        pconfig.push(
            {
                "title": "Default Temperature (0-1)",
                "key": "llm.temperature",
                "placeholder": "enter temperature",
                "default": 0,
                "type": "float",
            }
        )
        promptParam.html('')
        frm.configOptions(promptParam, pconfig, model);
    }
}

function oFind(obj, targetKey) {
    // Check if the current object has the target key
    if (obj.hasOwnProperty(targetKey)) {
        return obj[targetKey];
    }

    // Traverse the object tree recursively
    for (const key in obj) {
        if (typeof obj[key] === 'object') {
            const result = oFind(obj[key], targetKey);
            if (result !== undefined) {
                return result;
            }
        }
    }

    // Key not found in the object tree
    return undefined;
}

function testPromptModel() {
    var payload = {model:model};
    // payload.model.endpoint = $('#modelendpoint').val();
    frm.loading('')
    window.post( 'test_prompt_model', payload, res => {
        frm.loadingOut()
        console.log( 'RESPONSE', res.data )
        let result = oFind( res.data, 'response' ) ? 'Model responded succesfully' : 'Model responded with error. Please check model type and keys';
        frm.myAlert('Model Test Output', result, 'Ok');
        // $('.modal-dialog').css({maxWidth: 1024})
    })
}

function testModel() {

    if( model.type.match(/(pii_redaction|classification_prompt|summarization_prompt|qa_prompt)/) ) return testPromptModel();

    if( !modelTextSet() ) return;
    console.log( 'testModel', model )
    var payload = {model:model};
    payload.model.endpoint = $('#modelendpoint').val();
    frm.loading('')
    window.post( 'test_model', payload, res => {
        frm.loadingOut()
        frm.myAlert('Model Test Output', '<pre>'+JSON.stringify(res.data,null,'    ')+'</pre>', 'Ok');
        $('.modal-dialog').css({maxWidth: 1024})
    } )
}


function modelTextSet(ev) {
    try {
        var val = $('#modelpayload').val().trim();
        if( val ) {
            model.customTestPayload = JSON.parse(val);
            
            if( model.type == 'custom_bulkimageclassification' ) {
                if( !model.customTestPayload.source ) {
                    frm.myAlert('Model Test Payload', 'Payload must have the "source" field.', 'Ok', function () { $('#modelpayload')[0].focus() });
                    return null;
                }
                // $('#modelpayload').val(JSON.stringify(model.customTestPayload, null, '    '))
            }
            else if( model.type == 'custom_ner' ) {
                if( !model.customTestPayload.text ) {
                    frm.myAlert('Model Test Payload', 'Payload must have the "text" field with the correct page structure.', 'Ok', function () { $('#modelpayload')[0].focus() });
                    return null;
                }
                // $('#modelpayload').val(JSON.stringify(model.customTestPayload, null, '    '))
            }            
            else {
                {
                    // if( !model.customTestPayload.source ) {
                    //     frm.myAlert('Model Test Payload', 'Payload must have the "source" field with the document s3 path.', 'Ok', function () { $('#modelpayload')[0].focus() });
                    //     return null;
                    // }
                    // if( !model.customTestPayload.blocks ) {
                    //     frm.myAlert('Model Test Payload', 'Payload must have the "blocks" field with the correct Comprehend Block Section.', 'Ok', function () { $('#modelpayload')[0].focus() });
                    //     return null;
                    // }                    
                    // $('#modelpayload').val(JSON.stringify(model.customTestPayload, null, '    '))
                }
            }
        }
        else delete model.customTestPayload;

    } catch(e) {
        frm.myAlert('Model Test Payload', 'Please input a valid json payload', 'Ok', function () { $('#modelpayload')[0].focus() });
        return false;
    }
    return true;
}

let typeTid = null;
function initPanel() {
    window.topBarVisible();

    window.descriptor = descriptor;
    if (modelVisible) {
        $('#modelid').html('ID: ' + model.id);
    }
    $('#modeltype').val(model.type || 'custom_ner').on('change', function (ev) {
        model.type = $(this).val().trim();
        clearTimeout( typeTid );
        typeTid = setTimeout( typeAdjust, 100 );
    })
    $('#modelname').val(model.name).on('change', function (ev) {
        model.name = $(this).val().trim();
    })
    $('#modelendpoint').val(model.endpoint || '').on('change', function (ev) {
        model.endpoint = $(this).val().trim();
    })    
    if( !model.instanceType ) model.instanceType = $('#modelinstancetype').val();
    $('#modelinstancetype').val(model.instanceType).on('change', function (ev) {
        model.instanceType = $(this).val().trim();
    })
    if( !model.instanceCount ) model.instanceCount = $('#modelinstancecount').val()
    $('#modelinstancecount').val(model.instanceCount).on('change', function (ev) {
        model.instanceCount = $(this).val().trim();
    })

    $('#modelinstancetype').on('show', function(){alert('show!!!')})

    clearTimeout( typeTid );
    typeTid = setTimeout( typeAdjust, 100 );
// var testPayload = model.type == 'custom_ner' ? defaultCustomNerTestPayload : defaultCustomComprehendTestPayload;
    // $('#modelpayload').val(JSON.stringify(model.customTestPayload || testPayload, null, '    ')).on('change', modelTextSet )

    $('#modeltest').off('click').on('click', testModel )


    function flatLabels(labels) {
        if (!labels) return null;
        var list = [];
        function walk(labels) {
            for (var k in labels) {
                var o = clone(labels[k]);
                delete o.sublabels;
                o.name = k;
                list.push(o);
                if (labels[k].sublabels) walk(labels[k].sublabels);
            }
        }
        walk(labels);
        var labs = {};

        list.forEach(li => {
            labs[li.name] = li;
        });
        console.log('flatLabels', clone(labels), clone(labs))

        return labs;
    }

    console.log( 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
    function singleOption(olist, cname, f, val, idx) {
        $('.' + cname).each((eidx, e) => {
            if (eidx != idx && $(e).val() == val) {
                // console.log( 'element', eidx, $(e).val() );
                $(e).val('')
                olist[eidx].value[f] = ''
                // $(e).change();
            }
        })
    }


    console.log( 'parameters', model.parameters )
    frm.optionList($('.model-parameters'), model.parameters, {
        fields: {
            'key': { type: 'text', placeholder: 'Enter Parameter Key', label: 'Parameter Key' },
            'value': { type: 'text', placeholder: 'Enter Parameter Value', label: 'Prameter Value' },
            'header': { type: 'boolean', label: 'Header', forceWidth: 150  },
        },
        defaultField: 'key',
        fieldKey: 'key',
        subLabels: false,
        maxSubLabels: 0,
        callbackOnInit: true,
    }, function (o) {
        model.parameters = o;
        console.log( 'parameters', model.parameters )
    });


    function labelPanel() {
        var fields = {
            'color': { type: 'color', label: 'Color', className: 'option-color' },
            'label': { type: 'text', placeholder: 'Enter Label', label: 'Label' },
            'alias': { type: 'text', placeholder: 'Enter Alias', label: 'Alias', className: 'option-alias' },
        };


        model.labels = flatLabels(model.labels)

        console.log( 'LABELS', model.labels )
        frm.optionList($('.model-labels'), model.labels || {}, {
            labelPlaceholder: 'Enter Label name',
            fields: fields,
            defaultField: 'color',
            fieldKey: 'label',
            // subLabels: true,
            // maxSubLabels: 2,
            callbackOnInit: true,
            optionListCallback: singleOption,
        }, function (o) {
            model.labels = o;
        });
    }
    labelPanel();

    console.log( 'RELATIONSIPS', model.relationships )
    frm.optionList($('.model-relationships'), model.relationships || {}, {
        labelPlaceholder: 'Enter label name',
        fields: {
            'color': { type: 'color', label: 'Color', className: 'option-color' },
            'label': { type: 'text', placeholder: 'Enter Label', label: 'Label' },
            'alias': { type: 'text', placeholder: 'Enter Alias', label: 'Alias', className: 'option-alias' },
        },
        defaultField: 'color',
        fieldKey: 'label',
        subLabels: false,
        maxSubLabels: 0,
        callbackOnInit: true,
    }, function (o) {
        model.relationships = o;
    });
}

var modelCore = [
    'type',
    'name',
    'instanceType',
    'instanceCount',
    'endpoint',
    'parameters',
    'labels',
    'customTestPayload',
    'relationships',
];


var model = {id:null,name:null,company:null,instanceType:null,instanceCount:null}
window.model = model;
var modelDelete = false;
var modelVisible = false;

function ModelEdit(prop) {
    function saveModel(callback) {
        frm.removeInlineErrors() // added 23/1 mani

        if( model.type.match(/^(custom_ner|custom_ocr)$/) && (!model.labels || !Object.keys(model.labels).length )) 
            return frm.myAlert( 'Save Model', 'Please add the expected returned labels from the custom model', 'Ok' );
        // return console.log( 'SAVEMODEL', model );
        // if( !pdfs.length && !keepDocs ) return frm.myAlert( 'Save Project', 'Please import files by loading a valid manifest', 'Ok' );
        // if( !descriptor ) return frm.myAlert( 'Save Project', 'Please import a valid descriptor', 'Ok' );
        if (!model.name || model.name.trim() == '') {
            return frm.inlineError($('#modelname'),'Please choose a name for the model')// added 19/1 mani
            // return frm.myAlert('Save Model', 'Please choose a name for the model', 'Ok', function () { $('.model-name').focus() });
        }
        model.endpoint = $('#modelendpoint').val();
        if( frm.requiredInputs() ) return;

        console.log( 'save_model', JSON.stringify(model) );
        window.post('save_model', {model:model}, function (res) {
            console.log('SAVE', res.data )
            if (res.data.status === 0) return frm.myAlert('Model Save', res.data.value);
            // window.GlobalVars.ModelId = ModelId;
            // window.GlobalVars.ModelCompany = modelCompany;
            // window.saveSession();
            // if (callback) return callback();
            window.goPage('models');
        });
    }

    function exportModel(ev) {
        ev.preventDefault();
        var emodel = clone(model)
        delete emodel.id;
        var blob = new Blob([JSON.stringify(emodel, null, '\t')], { type: "text/plain;charset=utf-8" });
        var url = window.URL.createObjectURL(blob);

        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.setAttribute("download", "model.json");
        a.click();
        window.URL.revokeObjectURL(url);
    }


    function initModel() {
        var pageId = (window.GlobalVars.pageMenu && window.GlobalVars.pageMenu.id) || null;

        let mtype = $('#modeltype').html('');
        for( let t in window.modelTypes ) {
            mtype.append( $('<option value="'+t+'">'+window.modelTypes[t]+'</option>'))
        }
        $('.model-files').hide();
        // $('#topbuttons').html('');

        if (0 && window.hasPriv('admin', 'c_admin')) {
            var projBut = $('<Button id="browseProjects" variant="primary" type="submit" class="mt-2 btn btn-primary">Back to Projects</Button>')
            projBut.on('click', () => {
                window.GlobalVars.ModelId = null;
                window.saveSession();
                window.goPage('nlpProjectBrowse');
            })
            $('#topbuttons').append(projBut);
        }

        model.id = window.GlobalVars.ModelId || window.createId();
        if (!window.GlobalVars.ModelCompany) window.GlobalVars.ModelCompany = window.GlobalVars.userCompany;
        model.company = window.GlobalVars.ModelCompany;
        
        // $('#pageTitle').text( window.GlobalVars.ModelId ? 'Edit PDF Project - ' + window.GlobalVars.PDFProjectName : 'Create New PDF Project');
        $('#manifest').html('(no dataaaa)');
        $('#import').off('click').on('click', saveModel);
        $('#delmodel').off('click').on('click', function(){
            model.delete = true;
            saveModel()
        });
        // $('.model-files').html('<b>Project Files:</b> ' + pdfs.length );


        $('#topbuttons').html('<button id="loaddescriptor" class="btn btn-pink mt-0 mr-2"><i class="fa fa-download mr-2"></i>Import Model</button><button id="exportdescriptor" class="btn btn-pink mt-0 mr-2"><i class="fa fa-upload mr-2"></i>Export Model</button>');
        window.uploadButton( $('#loaddescriptor'), '.json', function(d){
            processDescriptor( atob(d) );
        });
        $('#exportdescriptor').off('click').on('click', exportModel );

        // window.uploadButton($('#loaddescriptor'), '.json', function (d) {
        //     processDescriptor(atob(d));
        // });
        $('#exportdescriptor').off('click').on('click', exportModel);


        if (window.GlobalVars.ModelId) {
            var match = { id: model.id };
            window.post('find_models', { match: match }, function (res) {
                modelVisible = true;
                console.log( 'FIND_MODELS', res.data )
                if (!res.data.count) return;
                var m = res.data.records[0];
                console.log('MODEL', model, m);
                model.type = m.type || 'sagemaker';
                oldModelType = model.type;
                model.name = m.name;
                model.company = m.company;
                model.instanceType = m.instanceType;
                model.instanceCount = m.instanceCount;
                model.labels = m.labels || {};
                model.relationships = m.relationships || {};
                model.parameters = m.parameters || {};
                model.endpoint = m.endpoint || '';
                model.customTestPayload = m.customTestPayload || '';
                model.llm = m.llm;
                model.embeddingModel = m.embeddingModel || '';
                model.embedding_model_config = m.embedding_model_config || null;
                
                model.modelConcurrency = m.modelConcurrency || 10;
                model.textChunkSize = m.textChunkSize;
                model.textChunkOverlap = m.textChunkOverlap;
                $('#delmodel').removeClass('hidden')
                initPanel();
            });
        }
        else {
            // wizzSaveCancel();
            modelVisible = false
            $('#import').addClass('mr-3')
            initPanel();
        }



    }

    $(function () {
        var loc = window.location.href; // returns the full URL
        if (/#Project%20Labels%20&%20Relationships/.test(loc)) {
            $('.wizzbtn').addClass('last_step_btns');
        }
    });

    useEffect(function (a) {
        initModel();
    });

    return (
        <div fluid="md p-0" className="maincontent">
            <div className="row">
                <Col ssm={9} className="mt-3">
                    <div className="wizzbtn">
                        <Button id="import" variant="primary" type="button" className="ml-3 btn btn-primary"><i class=" mr-2 fa fa-floppy-o"></i> Save Model</Button>
                        <Button id="delmodel" variant="danger" type="button" className="ml-2 mr-3 btn btn-danger hidden"><i class="fa fa-trash-o mr-2"></i> Delete Model</Button>
                    </div>
                    <div id="topbuttons" className="importexport">
                    <Button id="loaddescriptor" variant="primary" type="button" className="step2"><img className="svg_logo" src="imgs/descriptor.svg" />Load Model</Button>
                    <Button id="exportdescriptor" variant="primary" type="button" className="step2"><img className="svg_logo" src="imgs/descriptor.svg" />Export Model</Button>

                    </div>
                    <div className="project-panel mt-3">
                        <div className="step1">
                            <div className="project-name-div project-section">
                            <button class=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseTwenty-Five" aria-expanded="true" aria-controls="collapseTwenty-Five">
                            <h1>Model Info</h1><i className="fa fa-chevron-down acc"></i></button>
					<div id="collapseTwenty-Five" class="collapse show modelid" aria-labelledby="headingTwenty-Five" >
                                <div id="modelid" className="model-id"></div>
                                <label htmlFor="modelinstancecount">Model Type *</label>
                                <select placeholder="Model Recipes" type="text" id="modeltype" className="mb-4 form-control">
                                </select>
                                <label htmlFor="modelname">Model Name *</label>
                                <input placeholder="Model Name" type="text" id="modelname" className="mb-4 form-control" />
                                <div className="mfield mcustom apiurl">
                                    <label htmlFor="modelendpoint">Rest API Endpoint URL </label>
                                    <input placeholder="Endpoint URL" type="text" id="modelendpoint" className="mb-4 form-control" />
                                </div>
                                <div className="mfield msage">
                                    <label htmlFor="modelinstancetype">ML Instance Type</label>
                                    <select placeholder="ML Instance Type" type="text" id="modelinstancetype" className="mb-4 form-control">
                                        <option value="ml.m5.xlarge">ml.m5.xlarge</option>
                                        <option value="ml.c5.xlarge">ml.c5.xlarge</option>
                                    </select>

                                    <label htmlFor="modelinstancecount">ML Instance Count</label>
                                    <select placeholder="ML Instance Count" type="text" id="modelinstancecount" className="mb-4 form-control">
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                    </select>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="step1 stype-NER">
                            <div className="project-section panel-test mfield mcustom">
                            <button class=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseTwenty-Six" aria-expanded="true" aria-controls="collapseTwenty-Six">
                            <h1>Model Parameters</h1><i className="fa fa-chevron-down acc"></i></button>
					            <div id="collapseTwenty-Six" class="collapse show " aria-labelledby="headingTwenty-Six" >  
                                <div className="model-prompt-parameters"></div>
                                <div className="model-parameters"></div>
                                <div className="model-payload">
                                    <h1>Test the Model Payload</h1>
                                    <table>
                                    <tbody>
                                        <tr>
                                        <td><textarea className="model-test form-control" placeholder="test json payload" id="modelpayload"></textarea>
                                        </td></tr>
                                        <tr><td><Button id="modeltest" variant="primary" type="button" className="mt-2 mb-2 btn btn-primary">Test</Button>
                                        </td></tr>
                                    </tbody>
                                    </table>
                                </div>
                            </div>
                            </div>
                            <div className="project-section panel-labels">
                            <button class=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseTwenty-Seven" aria-expanded="true" aria-controls="collapseTwenty-Seven">
                            <h1>Labels</h1><i className="fa fa-chevron-down acc"></i></button>
					        <div id="collapseTwenty-Seven" class="collapse show " aria-labelledby="headingTwenty-Seven" >  
                                <div className="model-labels-bool"></div>
                                <div className="model-labels"></div>
                            </div></div>
                            <div className="project-section panel-relationships">
                            <button class=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseTwenty-Eight" aria-expanded="true" aria-controls="collapseTwenty-Eight">
                            <h1>Relationships</h1><i className="fa fa-chevron-down acc"></i></button>
					        <div id="collapseTwenty-Eight" class="collapse show " aria-labelledby="headingTwenty-Eight" > 
                                <div className="model-relationships-bool"></div>
                                <div className="model-relationships"></div>
                            </div></div>
                        </div>
                    </div>
                </Col>

                <Col sm={2} className="mt-3 import-column">

                </Col>
            </div>

        </div>

    )
}

var defaultCustomNerTestPayload = {
    "text": {
        "1": "This is a text by Michael Smith",
        "2": "A paper from Oxford University"
    }
};

var defaultCustomBulkImageClassificationTest = {
    "source": "s3://object-pocs/pdf-ocr/sources/testimage.png"
}

var defaultCustomOcrExtractTest = {
    "source": "https://sandbox.tensoract.com/testfiles/test_text.png"
}


var defaultCustomComprehendTestPayload = {
    blocks: [
        {
            "BlockType": "LINE",
            "Id": "f21456c6-46b9-44ed-b953-5bd39f14e7d3",
            "Text": "This is a text by Michael Smith",
            "Geometry": {
                "BoundingBox": {
                    "Width": 0.2495206594467163,
                    "Top": 0.08645293116569519,
                    "Left": 0.11983149498701096,
                    "Height": 0.013614434748888016
                },
                "Polygon": [
                    {
                        "X": 0.11983149498701096,
                        "Y": 0.08645293116569519
                    },
                    {
                        "X": 0.36935215443372726,
                        "Y": 0.08645293116569519
                    },
                    {
                        "X": 0.36935215443372726,
                        "Y": 0.1000673659145832
                    },
                    {
                        "X": 0.11983149498701096,
                        "Y": 0.1000673659145832
                    }
                ]
            },
            "Relationships": [
                {
                    "Ids": [
                        "86ba6074-2a0f-42cb-9cb9-1b2640f6725a",
                        "4d985378-5fd3-49ec-95e4-7ee51a58b907",
                        "51100a14-8c26-4fcd-a7ef-4dbce9bef749",
                        "f5bab5c2-4357-4f9d-9219-e5cc3a445bff",
                        "1afb5723-b269-4025-a4fb-66118fab2b8a",
                        "efb264cb-25d4-4dd3-b721-e450af122070",
                        "5c8d99e7-6be9-4aed-9b46-b3c5915619ec"
                    ],
                    "Type": "CHILD"
                }
            ],
            "Page": 1,
            "parentBlockIndex": -1,
            "blockIndex": 0
        },
        {
            "BlockType": "WORD",
            "Id": "86ba6074-2a0f-42cb-9cb9-1b2640f6725a",
            "Text": "This",
            "Geometry": {
                "BoundingBox": {
                    "Width": 0.03481177240610123,
                    "Top": 0.08679214864969254,
                    "Left": 0.11983368545770645,
                    "Height": 0.010582569986581802
                },
                "Polygon": [
                    {
                        "X": 0.11983368545770645,
                        "Y": 0.08679214864969254
                    },
                    {
                        "X": 0.15464545786380768,
                        "Y": 0.08679214864969254
                    },
                    {
                        "X": 0.15464545786380768,
                        "Y": 0.09737471863627434
                    },
                    {
                        "X": 0.11983368545770645,
                        "Y": 0.09737471863627434
                    }
                ]
            },
            "Relationships": [],
            "Page": 1,
            "parentBlockIndex": 0,
            "blockIndex": 1,
            "parent": "f21456c6-46b9-44ed-b953-5bd39f14e7d3"
        },
        {
            "BlockType": "WORD",
            "Id": "4d985378-5fd3-49ec-95e4-7ee51a58b907",
            "Text": "is",
            "Geometry": {
                "BoundingBox": {
                    "Width": 0.013491575606167316,
                    "Top": 0.08684605360031128,
                    "Left": 0.1601123809814453,
                    "Height": 0.01047662552446127
                },
                "Polygon": [
                    {
                        "X": 0.1601123809814453,
                        "Y": 0.08684605360031128
                    },
                    {
                        "X": 0.17360395658761263,
                        "Y": 0.08684605360031128
                    },
                    {
                        "X": 0.17360395658761263,
                        "Y": 0.09732267912477255
                    },
                    {
                        "X": 0.1601123809814453,
                        "Y": 0.09732267912477255
                    }
                ]
            },
            "Relationships": [],
            "Page": 1,
            "parentBlockIndex": 0,
            "blockIndex": 2,
            "parent": "f21456c6-46b9-44ed-b953-5bd39f14e7d3"
        },
        {
            "BlockType": "WORD",
            "Id": "51100a14-8c26-4fcd-a7ef-4dbce9bef749",
            "Text": "a",
            "Geometry": {
                "BoundingBox": {
                    "Width": 0.01071743294596672,
                    "Top": 0.08937358856201172,
                    "Left": 0.17823287844657898,
                    "Height": 0.008090201765298843
                },
                "Polygon": [
                    {
                        "X": 0.17823287844657898,
                        "Y": 0.08937358856201172
                    },
                    {
                        "X": 0.1889503113925457,
                        "Y": 0.08937358856201172
                    },
                    {
                        "X": 0.1889503113925457,
                        "Y": 0.09746379032731056
                    },
                    {
                        "X": 0.17823287844657898,
                        "Y": 0.09746379032731056
                    }
                ]
            },
            "Relationships": [],
            "Page": 1,
            "parentBlockIndex": 0,
            "blockIndex": 3,
            "parent": "f21456c6-46b9-44ed-b953-5bd39f14e7d3"
        },
        {
            "BlockType": "WORD",
            "Id": "f5bab5c2-4357-4f9d-9219-e5cc3a445bff",
            "Text": "text",
            "Geometry": {
                "BoundingBox": {
                    "Width": 0.03145330399274826,
                    "Top": 0.08725614845752716,
                    "Left": 0.19293242692947388,
                    "Height": 0.01015542447566986
                },
                "Polygon": [
                    {
                        "X": 0.19293242692947388,
                        "Y": 0.08725614845752716
                    },
                    {
                        "X": 0.22438573092222214,
                        "Y": 0.08725614845752716
                    },
                    {
                        "X": 0.22438573092222214,
                        "Y": 0.09741157293319702
                    },
                    {
                        "X": 0.19293242692947388,
                        "Y": 0.09741157293319702
                    }
                ]
            },
            "Relationships": [],
            "Page": 1,
            "parentBlockIndex": 0,
            "blockIndex": 4,
            "parent": "f21456c6-46b9-44ed-b953-5bd39f14e7d3"
        },
        {
            "BlockType": "WORD",
            "Id": "1afb5723-b269-4025-a4fb-66118fab2b8a",
            "Text": "by",
            "Geometry": {
                "BoundingBox": {
                    "Width": 0.019999273121356964,
                    "Top": 0.08696075528860092,
                    "Left": 0.22850285470485687,
                    "Height": 0.012931191362440586
                },
                "Polygon": [
                    {
                        "X": 0.22850285470485687,
                        "Y": 0.08696075528860092
                    },
                    {
                        "X": 0.24850212782621384,
                        "Y": 0.08696075528860092
                    },
                    {
                        "X": 0.24850212782621384,
                        "Y": 0.09989194665104151
                    },
                    {
                        "X": 0.22850285470485687,
                        "Y": 0.09989194665104151
                    }
                ]
            },
            "Relationships": [],
            "Page": 1,
            "parentBlockIndex": 0,
            "blockIndex": 5,
            "parent": "f21456c6-46b9-44ed-b953-5bd39f14e7d3"
        },
        {
            "BlockType": "WORD",
            "Id": "efb264cb-25d4-4dd3-b721-e450af122070",
            "Text": "Michael",
            "Geometry": {
                "BoundingBox": {
                    "Width": 0.06363342702388763,
                    "Top": 0.0867791473865509,
                    "Left": 0.25340330600738525,
                    "Height": 0.010836437344551086
                },
                "Polygon": [
                    {
                        "X": 0.25340330600738525,
                        "Y": 0.0867791473865509
                    },
                    {
                        "X": 0.3170367330312729,
                        "Y": 0.0867791473865509
                    },
                    {
                        "X": 0.3170367330312729,
                        "Y": 0.09761558473110199
                    },
                    {
                        "X": 0.25340330600738525,
                        "Y": 0.09761558473110199
                    }
                ]
            },
            "Relationships": [],
            "Page": 1,
            "parentBlockIndex": 0,
            "blockIndex": 6,
            "parent": "f21456c6-46b9-44ed-b953-5bd39f14e7d3"
        },
        {
            "BlockType": "WORD",
            "Id": "5c8d99e7-6be9-4aed-9b46-b3c5915619ec",
            "Text": "Smith",
            "Geometry": {
                "BoundingBox": {
                    "Width": 0.0472177192568779,
                    "Top": 0.08674612641334534,
                    "Left": 0.32213443517684937,
                    "Height": 0.0109197236597538
                },
                "Polygon": [
                    {
                        "X": 0.32213443517684937,
                        "Y": 0.08674612641334534
                    },
                    {
                        "X": 0.36935215443372726,
                        "Y": 0.08674612641334534
                    },
                    {
                        "X": 0.36935215443372726,
                        "Y": 0.09766585007309914
                    },
                    {
                        "X": 0.32213443517684937,
                        "Y": 0.09766585007309914
                    }
                ]
            },
            "Relationships": [],
            "Page": 1,
            "parentBlockIndex": 0,
            "blockIndex": 7,
            "parent": "f21456c6-46b9-44ed-b953-5bd39f14e7d3"
        },
        {
            "BlockType": "LINE",
            "Id": "2968b6bc-068d-4743-83a3-c96ec1de1dd7",
            "Text": "A paper from Oxford University",
            "Geometry": {
                "BoundingBox": {
                    "Width": 0.2536085247993469,
                    "Top": 0.12080135941505432,
                    "Left": 0.11927739530801773,
                    "Height": 0.013865767046809196
                },
                "Polygon": [
                    {
                        "X": 0.11927739530801773,
                        "Y": 0.12080135941505432
                    },
                    {
                        "X": 0.37288592010736465,
                        "Y": 0.12080135941505432
                    },
                    {
                        "X": 0.37288592010736465,
                        "Y": 0.13466712646186352
                    },
                    {
                        "X": 0.11927739530801773,
                        "Y": 0.13466712646186352
                    }
                ]
            },
            "Relationships": [
                {
                    "Ids": [
                        "1c660db0-9b70-423e-a9be-8b0f98faebde",
                        "44e07eae-01da-48ee-b791-06607bda9e18",
                        "1f1983b1-cce5-4d29-849f-5641ce9a232f",
                        "826b5497-de05-4f41-a2b9-58d222d3d569",
                        "928140af-c108-4bb8-8cb1-63fca57b9021"
                    ],
                    "Type": "CHILD"
                }
            ],
            "Page": 1,
            "parentBlockIndex": -1,
            "blockIndex": 8
        },
        {
            "BlockType": "WORD",
            "Id": "1c660db0-9b70-423e-a9be-8b0f98faebde",
            "Text": "A",
            "Geometry": {
                "BoundingBox": {
                    "Width": 0.013435040600597858,
                    "Top": 0.12116716802120209,
                    "Left": 0.11927954107522964,
                    "Height": 0.01081876177340746
                },
                "Polygon": [
                    {
                        "X": 0.11927954107522964,
                        "Y": 0.12116716802120209
                    },
                    {
                        "X": 0.1327145816758275,
                        "Y": 0.12116716802120209
                    },
                    {
                        "X": 0.1327145816758275,
                        "Y": 0.13198592979460955
                    },
                    {
                        "X": 0.11927954107522964,
                        "Y": 0.13198592979460955
                    }
                ]
            },
            "Relationships": [],
            "Page": 1,
            "parentBlockIndex": 8,
            "blockIndex": 9,
            "parent": "2968b6bc-068d-4743-83a3-c96ec1de1dd7"
        },
        {
            "BlockType": "WORD",
            "Id": "44e07eae-01da-48ee-b791-06607bda9e18",
            "Text": "paper",
            "Geometry": {
                "BoundingBox": {
                    "Width": 0.04781590402126312,
                    "Top": 0.12357227504253387,
                    "Left": 0.13622494041919708,
                    "Height": 0.01081964373588562
                },
                "Polygon": [
                    {
                        "X": 0.13622494041919708,
                        "Y": 0.12357227504253387
                    },
                    {
                        "X": 0.1840408444404602,
                        "Y": 0.12357227504253387
                    },
                    {
                        "X": 0.1840408444404602,
                        "Y": 0.1343919187784195
                    },
                    {
                        "X": 0.13622494041919708,
                        "Y": 0.1343919187784195
                    }
                ]
            },
            "Relationships": [],
            "Page": 1,
            "parentBlockIndex": 8,
            "blockIndex": 10,
            "parent": "2968b6bc-068d-4743-83a3-c96ec1de1dd7"
        },
        {
            "BlockType": "WORD",
            "Id": "1f1983b1-cce5-4d29-849f-5641ce9a232f",
            "Text": "from",
            "Geometry": {
                "BoundingBox": {
                    "Width": 0.03775444254279137,
                    "Top": 0.1211390346288681,
                    "Left": 0.18807139992713928,
                    "Height": 0.01070238184183836
                },
                "Polygon": [
                    {
                        "X": 0.18807139992713928,
                        "Y": 0.1211390346288681
                    },
                    {
                        "X": 0.22582584246993065,
                        "Y": 0.1211390346288681
                    },
                    {
                        "X": 0.22582584246993065,
                        "Y": 0.13184141647070646
                    },
                    {
                        "X": 0.18807139992713928,
                        "Y": 0.13184141647070646
                    }
                ]
            },
            "Relationships": [],
            "Page": 1,
            "parentBlockIndex": 8,
            "blockIndex": 11,
            "parent": "2968b6bc-068d-4743-83a3-c96ec1de1dd7"
        },
        {
            "BlockType": "WORD",
            "Id": "826b5497-de05-4f41-a2b9-58d222d3d569",
            "Text": "Oxford",
            "Geometry": {
                "BoundingBox": {
                    "Width": 0.05505376681685448,
                    "Top": 0.12096304446458817,
                    "Left": 0.23039619624614716,
                    "Height": 0.011384925805032253
                },
                "Polygon": [
                    {
                        "X": 0.23039619624614716,
                        "Y": 0.12096304446458817
                    },
                    {
                        "X": 0.28544996306300163,
                        "Y": 0.12096304446458817
                    },
                    {
                        "X": 0.28544996306300163,
                        "Y": 0.13234797026962042
                    },
                    {
                        "X": 0.23039619624614716,
                        "Y": 0.13234797026962042
                    }
                ]
            },
            "Relationships": [],
            "Page": 1,
            "parentBlockIndex": 8,
            "blockIndex": 12,
            "parent": "2968b6bc-068d-4743-83a3-c96ec1de1dd7"
        },
        {
            "BlockType": "WORD",
            "Id": "928140af-c108-4bb8-8cb1-63fca57b9021",
            "Text": "University",
            "Geometry": {
                "BoundingBox": {
                    "Width": 0.08125418424606323,
                    "Top": 0.12127944082021713,
                    "Left": 0.2916315495967865,
                    "Height": 0.01329045556485653
                },
                "Polygon": [
                    {
                        "X": 0.2916315495967865,
                        "Y": 0.12127944082021713
                    },
                    {
                        "X": 0.37288573384284973,
                        "Y": 0.12127944082021713
                    },
                    {
                        "X": 0.37288573384284973,
                        "Y": 0.13456989638507366
                    },
                    {
                        "X": 0.2916315495967865,
                        "Y": 0.13456989638507366
                    }
                ]
            },
            "Relationships": [],
            "Page": 1,
            "parentBlockIndex": 8,
            "blockIndex": 13,
            "parent": "2968b6bc-068d-4743-83a3-c96ec1de1dd7"
        }
    ]
};


export default ModelEdit
